<!-- 获取车辆欠费记录 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "carNo": "粤12313",
                "parkCodeList": ["2KNTYVWC"],
                "areaIds": [],
                "openGateTimeFrom": "20171015000000",
                "openGateTimeTo": "20171015141333",
                "channelName": "入口",
                "openGateType": "1",
                "entranceType": "1",
                "parkSystemType": "1",
                "remark": "备注",
                "pageNum": "1",
                "pageSize": "2"
            },
            responseCode: 	{
                "data": {
                    "currCount": 1,
                    "recordInList": [

                    ],
                    "total": 600
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            },infoData: {
                explain: "第三方接入系统请求智慧停车开放平台查询非系统开闸记录",
                t_url: this.commonUrls.test+"getAbnormalOpenGateList",
                p_url: this.commonUrls.prod+"getAbnormalOpenGateList",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'carNo', info2: '否', info3: 'String', info4: '车牌号码' },
                        { info1: 'parkCodeList', info2: '是', info3: 'String[]', info4: '停车场编号列表' },
                        { info1: 'openGateTimeFrom', info2: '是', info3: 'String', info4: '开闸起始时间，格式yyyyMMddHHmmss， 起始时间与结束时间间隔不能超过3个月' },
                        { info1: 'openGateTimeTo', info2: '是', info3: 'String', info4: '开闸结束时间，格式：yyyyMMddHHmmss' },
                      { info1: 'areaIds', info2: '否', info3: 'String[]', info4: '区域id列表' },
                      { info1: 'channelName', info2: '否', info3: 'String', info4: '通道名称' },
                      { info1: 'openGateType', info2: '否', info3: 'Integer', info4: '非系统开闸类型: 0未确认，1遥控开闸，2可疑跟车，不填默认全部' },
                      { info1: 'entranceType', info2: '否', info3: 'Integer', info4: '通道类型，1进场；2出场；不填默认全部' },
                      { info1: 'remark', info2: '否', info3: 'String', info4: '备注' },
                      { info1: 'parkSystemType', info2: '否', info3: 'Integer', info4: '停车场系统类型：0 VEMS停车场，1云停车场，2第三方停车场，3路边停车场' },
                      { info1: 'pageNum', info2: '否', info3: 'Integer', info4: '第几页，从1开始，默认1' },
                        { info1: 'pageSize', info2: '否', info3: 'Integer', info4: '每页多少条，最多100条，默认10' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'total', info2: '是', info3: 'Integer', info4: '记录总数' },
                        { info1: 'currCount', info2: '是', info3: 'Integer', info4: '当前获取的记录数' },
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '记录列表' }
                        ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '否', info3: 'String', info4: '停车场编号' },
                        { info1: 'parkName', info2: '否', info3: 'String', info4: '停车场名称' },
                        { info1: 'parkingCode', info2: '否', info3: 'String', info4: '停车记录编号' },
                        { info1: 'carNo', info2: '否', info3: 'String', info4: '车牌号' },
                        { info1: 'cardNo', info2: '否', info3: 'String', info4: '卡号' },
                        { info1: 'openGateType', info2: '否', info3: 'String', info4: '系统开闸类型: 0未确认，1遥控开闸，2可疑跟车，不填默认全部' },
                        { info1: 'channelName', info2: '否', info3: 'String', info4: '通道名' },
                        { info1: 'channelCode', info2: '否', info3: 'String', info4: '通道编码' },
                        { info1: 'areaName', info2: '否', info3: 'String', info4: '区域名' },
                        { info1: 'enterTime', info2: '否', info3: 'String', info4: '进场时间，格式：yyyyMMddHHmmss' },
                        { info1: 'leaveTime', info2: '否', info3: 'String', info4: '离场时间，格式：yyyyMMddHHmmss' },
                        { info1: 'recordType', info2: '否', info3: 'String', info4: '记录类型 1进场 2出场' },
                        { info1: 'shouldCharge', info2: '否', info3: 'Decimal', info4: '停车费用' },
                        { info1: 'reliefCharge', info2: '否', info3: 'Decimal', info4: '减免金额' },
                        { info1: 'realCharge', info2: '否', info3: 'Decimal', info4: '实缴金额' },
                        { info1: 'enterImageArray', info2: '否', info3: 'JSONArray', info4: '进场图片列表[{"plateImage":"车牌图片直接访问url","carImage"："车身图片直接访问url"}]' },
                        { info1: 'leaveImageArray', info2: '否', info3: 'JSONArray', info4: '离场图片列表[{"plateImage":"车牌图片直接访问url","carImage"："车身图片直接访问url"}]' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/parking/record/getAbnormalOpenGateList.vue